import type { DocsSpace, DocsFolder, DocsPage } from "@siena-ai/design-system";
import type {
  SiteManifest,
  ManifestFolder,
  ManifestPageEntry,
  PublishedPage
} from "./types";

export function toDocsSpace(manifest: SiteManifest): DocsSpace {
  const s = manifest.space;
  return {
    id: s.uuid,
    name: s.name,
    emoji: s.emoji,
    subdomain: s.subdomain,
    branding: {
      logoUrl: s.branding.logoUrl || "",
      logoDarkUrl: s.branding.logoDarkUrl || "",
      homepageHeading: s.branding.homepageHeading || "",
      homepageDescription: s.branding.homepageDescription || ""
    },
    layout: { ...s.layout },
    access: { visibility: "public" },
    seo: { ...s.seo },
    brandColor: s.brandColor || "",
    linkedLiveChatId: s.linkedLiveChatId,
    chatButtonLabel: s.chatButtonLabel,
    position: 0,
    createdAt: manifest.generatedAt,
    updatedAt: manifest.generatedAt
  };
}

export function toDocsFolder(f: ManifestFolder): DocsFolder {
  return {
    id: f.uuid,
    knowledgeBaseId: "",
    emoji: f.emoji || "",
    name: f.name,
    description: "",
    position: f.position,
    createdAt: "",
    updatedAt: "",
    parentFolderId: f.parent_folder_uuid || null
  };
}

export function toDocsPage(entry: ManifestPageEntry): DocsPage {
  return {
    id: entry.uuid,
    folderIds: [entry.folder_uuid],
    title: entry.title,
    description: entry.description || "",
    emoji: entry.emoji,
    content: "",
    hasDraft: false,
    slug: entry.slug,
    slugHistory: [],
    status: "published",
    visibility: "public",
    tagIds: [],
    position: entry.position,
    createdBy: "",
    lastEditedBy: "",
    createdAt: entry.published_at || "",
    lastEditedAt: entry.last_edited_at || "",
    publishedAt: entry.published_at,
    reviewCycleDays: 0,
    askSienaEnabled: false,
    relatedPageIds: []
  };
}

export function toDocsPageFull(
  page: PublishedPage,
  folderUuid: string
): DocsPage {
  return {
    id: page.uuid,
    folderIds: [folderUuid],
    title: page.title,
    description: page.description || "",
    emoji: page.emoji,
    content: page.htmlContent,
    hasDraft: false,
    slug: page.slug,
    slugHistory: [],
    status: "published",
    visibility: "public",
    tagIds: [],
    position: 0,
    createdBy: "",
    lastEditedBy: "",
    createdAt: page.published_at,
    lastEditedAt: page.last_edited_at,
    publishedAt: page.published_at,
    reviewCycleDays: 0,
    askSienaEnabled: false,
    relatedPageIds: []
  };
}
